import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ImpersonationBanner = () => {
  const [impersonatedUser, setImpersonatedUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if we're impersonating a user
    const impersonatedUserData = sessionStorage.getItem('impersonatedUser');
    if (impersonatedUserData) {
      setImpersonatedUser(JSON.parse(impersonatedUserData));
    }
  }, []);

  const exitImpersonation = () => {
    // Restore original admin session
    const originalAdminToken = sessionStorage.getItem('originalAdminToken');
    if (originalAdminToken) {
      sessionStorage.setItem('adminToken', originalAdminToken);
      sessionStorage.removeItem('originalAdminToken');
    }
    
    // Clear impersonation data
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('uid');
    sessionStorage.removeItem('impersonatedUser');
    
    setImpersonatedUser(null);
    navigate('/admin-dashboard');
  };

  if (!impersonatedUser) return null;

  return (
    <div className="impersonation-banner">
      <span>
        🔑 Admin Mode: You are currently logged in as <strong>{impersonatedUser.fullName}</strong> ({impersonatedUser.email})
      </span>
      <button onClick={exitImpersonation}>
        Exit Impersonation
      </button>
    </div>
  );
};

export default ImpersonationBanner;
